<template>
  <div v-if="!this.$store.state.loadingChartData" :loading="this.$store.state.loadingChartData">
    <canvas id="outboundChart" style="max-height: 35rem" :loading="this.$store.state.loadingChartData"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  name: "student-chart",
  props: {
    chartType: String,
    chartData: Object,
    chartOptions: Object,
  },
  components: {
    Chart,
  },
  data() {
    return {
      sidebarStore: false,
      responsive: true,
      options: {
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Number of Students",
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Country",
              },
            },
          ],
        },
      },
    };
  },
  mounted() {
    let { chartType, chartData, chartOptions } = this;
    this.chartConstructor(chartType, chartData, chartOptions);
  },
  methods: {
    chartConstructor(chartType, chartData, chartOptions) {
      const chartElement = document.getElementById("outboundChart");
      const chart = new Chart(chartElement, {
        type: "bar",
        data: chartData,
        options: this.options,
      });
    },
  },
};
</script>
